import classNames from "classnames";
import { If } from "components";
import { Avatar } from "ui/Avatar";

import { PersonInfoProps } from "./PersonInfo.types";

import styles from "./PersonInfo.module.scss";

const PersonInfo = ({
  image,
  Placeholder,
  dimensions,
  personName,
  nameClassName,
  wrapperClassName,
  bottomText,
  topText,
  nameMarker,
  imageMarker,
  bottomTextClassName,
  children
}: PersonInfoProps) => {
  return (
    <div className={classNames(styles.personInfo, wrapperClassName)}>
      <div className={styles.personInfo_avatarContainer}>
        <Avatar
          image={image}
          Placeholder={Placeholder}
          dimensions={dimensions}
        />

        <If condition={imageMarker}>
          <div className={styles.personInfo_imageMarker}>{imageMarker}</div>
        </If>
      </div>
      <div>
        <If condition={topText}>
          <div className={styles.personInfo_topText}>{topText}</div>
        </If>
        <div className={classNames(styles.personInfo_name, nameClassName)}>
          {personName}
          {nameMarker}
        </div>
        <If condition={bottomText}>
          <div
            className={classNames(
              styles.personInfo_bottomText,
              bottomTextClassName
            )}
          >
            {bottomText}
          </div>
        </If>
        {children}
      </div>
    </div>
  );
};

export default PersonInfo;
